import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { VENDOR_LABELS, VENDOR_COLORS } from "@/lib/api";
import { PriceDropBadge, Price } from "@/components/PriceDrop";

export default function ProductCard({ product }) {
  const v = VENDOR_LABELS[product.vendor] || product.vendor;
  const c = VENDOR_COLORS[product.vendor] || { bg: "#0A0A0A", text: "#fff" };

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block brut bg-white overflow-hidden brut-hover"
    >
      <div className="relative aspect-[4/5] overflow-hidden border-b-2 border-black">
        <img
          src={product.image_url}
          alt={product.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {product.featured && (
          <span
            className="absolute top-3 left-3 brut pcs-bg-orange text-black px-2 py-1 font-mono text-[10px] uppercase tracking-widest"
            data-testid={`featured-badge-${product.slug}`}
          >
            Editor pick
          </span>
        )}
        <span
          className="absolute top-3 right-3 brut px-2 py-1 font-mono text-[10px] uppercase tracking-widest"
          style={{ backgroundColor: c.bg, color: c.text }}
        >
          {v}
        </span>
        <PriceDropBadge product={product} compact className="absolute bottom-3 left-3" />
      </div>

      <div className="p-4">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display text-lg leading-tight tracking-tight line-clamp-2">
            {product.title}
          </h3>
          <ArrowUpRight
            className="shrink-0 w-5 h-5 mt-0.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
            strokeWidth={2.5}
          />
        </div>
        <div className="mt-2 flex items-center justify-between gap-2">
          <span className="font-mono uppercase text-[11px] tracking-widest text-gray-600">
            From
          </span>
          <Price product={product} />
        </div>
      </div>
    </Link>
  );
}
